"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isDeepEmpty = isDeepEmpty;
const lodash_1 = require("lodash");
function isDeepEmpty(input) {
    if ((0, lodash_1.isEmpty)(input)) {
        return true;
    }
    if (typeof input === 'object') {
        for (const item of Object.values(input)) {
            // if item is not undefined and is a primitive, return false
            // otherwise dig deeper
            if ((item !== undefined && typeof item !== 'object') || !isDeepEmpty(item)) {
                return false;
            }
        }
        return true;
    }
    return (0, lodash_1.isEmpty)(input);
}
